<ng-container>
  <app-table-column name="tagRfid" size="large">
    <span content class="tag-rfid">
      {{ item.tagRfid || '---' }}
      <app-background-icon  *ngIf="item.isPallet && item.skuGroups?.length === 0"
        [backgroundColor]="'warning'" [icon]="'exclamation'"
        matTooltip="Pallet vazio">
      </app-background-icon>
    </span>
  </app-table-column>
  <app-table-column name="expected-position" size="medium">
    <span content>{{ expectedPosition || '---' }}</span>
  </app-table-column>
  <app-table-column name="found-position" size="medium">
    <span content>
      {{ foundPosition || '---' }}
      <app-background-icon *ngIf="isFoundOutsidePigeonhole"
        [backgroundColor]="'warning'" [icon]="'exclamation'" [size]="'small'"
        matTooltip="Encontrado fora do escaninho">
      </app-background-icon>
    </span>
  </app-table-column>
  <app-table-column name="expected-height" size="small">
    <span content>{{ expectedLevel }}</span>
  </app-table-column>
  <app-table-column name="found-height" size="small">
    <span content>{{ foundLevel }}</span>
  </app-table-column>
  <app-table-column name="status" size="medium">
    <span content>
      <div class="status-icon-wrapper">
        <app-background-icon [backgroundColor]="iconBackgroundColor" [icon]="icon"></app-background-icon>
        {{ crateState || "---" }}
      </div>
    </span>
  </app-table-column>
  <app-table-column name="action" size="small" *ngIf="report.state === 'AWAITING_ADMIN_APPROVAL' && isMissingPallets">
    <span content>
      <mat-checkbox color="primary" *ngIf="crateState === 'Perdido' " (change)="onCheckboxChange(item)"
        [disabled]="!canRemovePallet()">
      </mat-checkbox>
    </span>
  </app-table-column>
  <app-table-column name="pallet-details" size="small">
    <span content>
      <button mat-raised-button *ngIf="hasPalletDetails" (click)="onPalletDetailsClick(item)">
        Dados Do Pallet
      </button>
    </span>
  </app-table-column>
</ng-container>

